"use strict";

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerPlayer = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.concat.js");

var _playlistAudioTrack = require("./playlistAudioTrack");

var _utils = require("./utils");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * Basic audio utilities for playing speakers audio
 * @export
 * @class SpeakerPlayer
 */
var SpeakerPlayer = /*#__PURE__*/function () {
  /**
   * Creates an instance of SpeakerPlayer.
   * @param {string} url URL of the audio
   * @memberof SpeakerPlayer
   */
  function SpeakerPlayer(audioContext, id, url) {
    var _this = this;

    var prefetch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var fadingDurationInSeconds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;

    _classCallCheck(this, SpeakerPlayer);

    _defineProperty(this, "playing", false);

    _defineProperty(this, "fading", false);

    _defineProperty(this, "_isSafeToPlay", false);

    _defineProperty(this, "_fadingDestination", 0);

    _defineProperty(this, "_fading", false);

    this._context = audioContext;
    this._id = id;
    this.audio = new Audio();
    this.audio.crossOrigin = "anonymous";
    var cleanUrl = (0, _utils.cleanAudioURL)(url);
    this.audio.src = _playlistAudioTrack.silenceAudioBase64;
    this.audio.loop = true;
    this.audio.preload = "auto";
    this.audio.autoplay = false;
    this._audioSrc = this._context.createMediaElementSource(this.audio);
    this._gainNode = this._context.createGain();

    this._audioSrc.connect(this._gainNode);

    this._gainNode.connect(this._context.destination);

    this._gainNode.gain.setValueAtTime(0, 0); // initially 0 and fade later


    (0, _utils.makeAudioSafeToPlay)(this.audio, function () {
      return _this._isSafeToPlay = true;
    }, cleanUrl);
    this.audio.addEventListener("playing", function () {
      return _this.playing = true;
    });
    ["ended", "error", "pause"].forEach(function (e) {
      _this.audio.addEventListener(e, function () {
        return _this.playing = false;
      });
    });
    this._prefetch = prefetch;
    this._fadeDuration = fadingDurationInSeconds;
  }

  _createClass(SpeakerPlayer, [{
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._isSafeToPlay) {
                  _context.next = 3;
                  break;
                }

                if (!this.playing) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", true);

              case 3:
                _context.prev = 3;

                if (!(this._context.state !== "running")) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return this._context.resume();

              case 7:
                _context.next = 9;
                return this.audio.play();

              case 9:
                (0, _utils.speakerLog)("".concat(this._id, ": Speaker started! ").concat(this.audio.src));
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);
                console.error("Error playing speaker: ".concat(this._id), _context.t0);
                return _context.abrupt("return", false);

              case 16:
                return _context.abrupt("return", true);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 12]]);
      }));

      function play() {
        return _play.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: "fade",
    value: function fade() {
      var _this2 = this;

      var toVolume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._fadingDestination;
      var durationInSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._fadeDuration;
      if (this._fadingDestination === toVolume && this._fading) return;
      this._fadingDestination = toVolume; // assume it's already at the expected volume,
      // because there's always a small difference in decimals as gain.value is not accurate.

      if (Math.abs(this.volume() - this._fadingDestination) < 0.01) return;

      if (!this.playing) {
        // schedule to fade when it starts playing.
        this.audio.addEventListener("playing", function () {
          return _this2.fade();
        }, {
          once: true
        });
        return;
      }

      this._gainNode.gain.cancelScheduledValues(0);

      this._fading = true;

      this._gainNode.gain.linearRampToValueAtTime(toVolume, this._context.currentTime + durationInSeconds);

      setTimeout(function () {
        (0, _utils.speakerLog)("".concat(_this2._id, ": volume faded to \"").concat(_this2.volume(), "\"\""));
        _this2._fading = false;
      }, durationInSeconds * 1000);
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.audio.paused) {
        this.audio.pause();
        this.playing = false;
      }
    }
  }, {
    key: "fadeOutAndPause",
    value: function fadeOutAndPause() {
      var _this3 = this;

      if (this.audio.paused) return;
      if (this.volume() < 0.05) return this.pause();

      this._gainNode.gain.linearRampToValueAtTime(0, this._context.currentTime + this._fadeDuration);

      setTimeout(function () {
        // if audio was fading to something else
        // and couldn't managed to fade to 0 in 3 seconds, try again
        if (_this3.volume() > 0.05) _this3.fadeOutAndPause();else _this3.pause();
      }, this._fadeDuration * 1000);
    }
  }, {
    key: "volume",
    value: function volume() {
      return this._gainNode.gain.value;
    }
  }]);

  return SpeakerPlayer;
}();

exports.SpeakerPlayer = SpeakerPlayer;